//@ts-nocheck

import React, { useEffect } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

function BankAccountVerification() {
  const context = useOutletContext();
  const { activeStep, setActiveStep } = context || {};

  useEffect(() => {
    if (activeStep !== undefined && activeStep < 2) {
      setActiveStep(2);
    }
  }, [activeStep, setActiveStep]);

  return <Outlet />;
}

export default BankAccountVerification;
